
import React from "react";
import Fade from 'react-bootstrap/Collapse'
import { Row, Col } from 'react-grid-system';
import {useNavigate} from "react-router-dom";

function checkoutPage(ent_id){
  let page = [
      {
        ent_id: 1,
        name:"AI聲音濾鏡",
        link:"/company/voicefilter",
        product: "voicefilter",
        official: process.env.REACT_APP_OFFICIAL_VOICEFILTER
      },{
        ent_id: 2,
        name:"AI廣播助理",
        link:"/company/broadcastAssistant",
        product: "broadcastAssistant",
        official: process.env.REACT_APP_OFFICIAL_BROADCAST
      },{
        ent_id: 3,
        name:"AI知識中心",
        link:"/company/aichatbot",
        product: "aichatbot",
        official: process.env.REACT_APP_OFFICIAL_CPMAKER
      }
  ];
  for (let i=0; i < page.length; i++){
     if (page[i].ent_id === ent_id)
        return page[i];
   } 
  return null;
}
let CollapseComponent = (props) =>{
    
    //const [open, setOpen] = useState(true);
    let open = true;
    const navigate = useNavigate();
    //console.log("promo plain props"+ JSON.stringify(props.promoplainObj) );
    //console.log("ent => "+JSON.stringify(props.allEnt));
    //console.log("curent => "+JSON.stringify(props.curEnt));
    for (let i=0; i < props.allEnt.length; i++){
      props.allEnt[i].product = checkoutPage(props.allEnt[i].ent_id).product;
    }
    return (       
      <>
      {props.promoplainObj && props.allEnt ?
        <>
        <Row className="collapse_header label_text_white">
          <Col xs={6}  aria-controls="example-collapse-text" aria-expanded={open} className="label_text_center">
            <h5><label >產品名稱</label></h5>
          </Col>
        
          <Col xs={6} aria-controls="example-collapse-text" aria-expanded={open} className="label_text_center">
            <h5><label >優惠方案</label> </h5>
          </Col>
        </Row>

        <Fade in={open}>
          <div id="example-collapse-text" className="collapse_content label_text_black">
            {props.allEnt.map((item, index ) => 
              (item.ent_id === props.curEnt.ent_id)?
              <Row key={index} style={{backgroundColor:"#c5c5c5"}}>
                <Col xs={6} className="label_text_center " >
                <label style={{cursor:"pointer",color:"blue"}} onClick={()=>navigate(checkoutPage(item.ent_id).link,
                              {state:{"curEnt":item}})
                      }><h5>{checkoutPage(item.ent_id).name}</h5></label>
                <br/>
                <label style={{cursor:"pointer",color:"rgb(0, 128, 128)"}} onClick={()=>window.location.replace(checkoutPage(item.ent_id).official) 
                      }><h6>產品網站</h6></label>
                  
                </Col>
                <Col xs={6}  className="label_text_center">
                  <label style={{cursor:"pointer"}} onClick={()=>navigate(checkoutPage(item.ent_id).link,
                              {state:{"scroll":true,"curEnt":item}})
                      }><h5>{props.promoplainObj[index].promoplain_name}</h5></label>
                      
                </Col>
              </Row> :
              <Row key={index}>
                <Col xs={6} className="label_text_center ">
                <label style={{cursor:"pointer"}} onClick={()=>navigate(checkoutPage(item.ent_id).link,
                              {state:{"curEnt":item}})
                      }><h5>{checkoutPage(item.ent_id).name}</h5></label>
                      <br/>
                      <label style={{cursor:"pointer",color:"rgb(0, 128, 128)"}} onClick={()=>window.location.replace(checkoutPage(item.ent_id).official) 
                      }><h6>產品網站</h6></label>
                </Col>
                <Col xs={6}  className="label_text_center">
                  <label style={{cursor:"pointer"}} onClick={()=>navigate(checkoutPage(item.ent_id).link,
                              {state:{"scroll":true,"curEnt":item}})
                      }><h5>{props.promoplainObj[index].promoplain_name}</h5></label>
                </Col>
              </Row>               
            )}
          </div>
        </Fade></>:<div></div>
      }
            
        </>
    )
    
    
}

export default CollapseComponent;